import * as ErrorActions from '~app/actions/error';

function isPromise(val) {
  return val && typeof val.then === 'function';
}

export default ({dispatch}) => next => action => {
  try {
    const result = next(action);
    if (isPromise(result)) {
      result.catch(error => dispatch(ErrorActions.setGlobalError(error, action)));
    }
    return result;
  }
  catch (error) {
    dispatch(ErrorActions.setGlobalError(error, action));
    return error;
  }
};



// WEBPACK FOOTER //
// ./src/store/errorMiddleware.js